import {
  CUSTOM_STYLES_ELEMENT_ID,
  CUSTOM_STYLES_LINK_ELEMENT_ID,
} from 'utils/sdk/constants';

export class TailwindService {
  private static instance: TailwindService;
  private styleElement: HTMLStyleElement | null = null;
  private targetDocument: Document = document;
  private readonly STYLE_ID = 'branding-tailwind-vars';
  private readonly CUSTOM_STYLES_SELECTOR = `#${CUSTOM_STYLES_ELEMENT_ID}, #${CUSTOM_STYLES_LINK_ELEMENT_ID}`;

  private constructor() {}

  static getInstance(): TailwindService {
    if (!TailwindService.instance) {
      TailwindService.instance = new TailwindService();
    }
    return TailwindService.instance;
  }

  setTargetDocument(doc: Document): void {
    this.targetDocument = doc;
  }

  injectTailwindVariables(cssVariables: Record<string, string | undefined>): void {
    const cssText = this.generateBrandingCssStyles(cssVariables);
    this.updateBrandingStyleSheet(cssText);
  }

  private generateBrandingCssStyles(
    variables: Record<string, string | undefined>,
  ): string {
    if (Object.keys(variables).length === 0) {
      return '';
    }

    const cssRules = Object.entries(variables)
      .map(([key, value]) => `  --${key}: ${value};`)
      .join('\n');

    return `:root {\n  /* Chekin Branding Theme */\n${cssRules}\n}`;
  }

  private updateBrandingStyleSheet(cssText: string): void {
    this.removeBrandingStyleSheet();

    if (!cssText.trim()) {
      return;
    }

    this.styleElement = this.targetDocument.createElement('style');
    this.styleElement.id = this.STYLE_ID;
    this.styleElement.setAttribute('data-source', 'chekin-branding-theme');
    this.styleElement.setAttribute('data-timestamp', new Date().toISOString());
    this.styleElement.textContent = cssText;

    const customStylesElement = this.targetDocument.head.querySelector(
      this.CUSTOM_STYLES_SELECTOR,
    );

    if (customStylesElement) {
      this.targetDocument.head.insertBefore(this.styleElement, customStylesElement);
      return;
    }

    this.targetDocument.head.appendChild(this.styleElement);
  }

  private removeBrandingStyleSheet(): void {
    const existingElement = this.targetDocument.getElementById(this.STYLE_ID);
    if (existingElement) {
      existingElement.remove();
    }
    this.styleElement = null;
  }

  cleanup(): void {
    this.removeBrandingStyleSheet();
  }
}
